/*
 * Author: Roger
 * File Created: Friday, 24-09-13 02:12 pm
 * Last Modified: Friday, 24-09-27 11:20 am, by Dw
 */

import {
  Box,
  listClasses,
  listItemClasses,
  listItemTextClasses,
  styled,
  svgIconClasses,
  Typography,
  typographyClasses,
} from '@mui/material';

import Image from '@/components/Image';

export const PaymentTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '120%',
  marginBottom: '60px',
  display: 'inline',
  [`&:last-of-type`]: {
    color: '#7E61F3',
    marginLeft: '0.4em',
  },
  [theme.breakpoints.only('xs')]: {
    fontSize: '24px',
    lineHeight: '120%',
    display: 'block',
    [`&:last-of-type`]: {
      marginLeft: 0,
      marginBottom: '24px',
    },
    [`&:lang(zh)`]: {
      display: 'inline-block',
      marginBottom: '24px',
      [`&:last-of-type`]: {
        marginLeft: '0.4em',
      },
    },
  },
  [theme.breakpoints.only('sm')]: {
    fontSize: '28px',
  },
  [theme.breakpoints.only('md')]: {
    fontSize: '32px',
  },
}));

export const MoreInfoBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignSelf: 'stretch',
  [`& .${typographyClasses.h5}`]: {
    color: theme.palette.common.white,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '120%',
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px',
      lineHeight: '140%',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '18px',
      lineHeight: '120%',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '20px',
      lineHeight: '120%',
    },
  },
  [`& .${listClasses.root}`]: {
    paddingLeft: '16px',
    marginTop: '16px',
    [`& .${listItemClasses.root}`]: {
      padding: 0,
      display: 'list-item',
      listStyle: 'disc',
      marginBottom: '8px',
      [`& .${listItemTextClasses.root} span`]: {
        margin: 0,
        color: '#848E9C',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '140%',
        [theme.breakpoints.only('xs')]: {
          fontSize: '14px',
        },
        [theme.breakpoints.only('sm')]: {
          fontSize: '14px',
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '16px',
        },
      },
    },
  },
}));

export const MoreImageBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignSelf: 'stretch',
  [theme.breakpoints.only('xs')]: {
    marginBottom: '24px',
  },
}));

export const ProductImage = styled(Image)(() => ({
  width: '100%',
  height: 'auto',
  maxWidth: '584px',
  alignSelf: 'center',
}));

export const IconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  padding: '32px',
  border: '1px solid rgba(132, 142, 156, 0.20)',
  borderRadius: '8px',
  background: 'rgba(56, 54, 55, 0.20)',
  alignItems: 'center',
  gap: '32px',
  [theme.breakpoints.only('xs')]: {
    padding: '16px',
    gap: '16px',
    alignItems: 'flex-start',
  },
  [theme.breakpoints.only('sm')]: {
    padding: '20px',
    gap: '20px',
  },
  [theme.breakpoints.only('md')]: {
    padding: '24px',
    gap: '24px',
  },
  [`& .${svgIconClasses.root}`]: {
    width: '70px',
    height: '70px',
    [theme.breakpoints.only('xs')]: {
      width: '48px',
      height: '48px',
    },
    [theme.breakpoints.only('sm')]: {
      width: '54px',
      height: '54px',
    },
    [theme.breakpoints.only('md')]: {
      width: '60px',
      height: '60px',
    },
  },
  [`& .${typographyClasses.h5}`]: {
    color: theme.palette.common.white,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: 'normal',
    marginBottom: '12px',
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px',
      fontWeight: 700,
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '16px',
      fontWeight: 600,
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '18px',
      fontWeight: 600,
    },
  },
  [`& .${listClasses.root}`]: {
    paddingLeft: '16px',
    [`& .${listItemClasses.root}`]: {
      padding: 0,
      display: 'list-item',
      listStyle: 'disc',
      marginBottom: '8px',
      [`& .${listItemTextClasses.root} span`]: {
        margin: 0,
        color: '#848E9C',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '140%',
        [theme.breakpoints.only('xs')]: {
          fontSize: '14px',
          lineHeight: 'normal',
        },
        [theme.breakpoints.only('sm')]: {
          fontSize: '14px',
          lineHeight: '120%',
        },
        [theme.breakpoints.only('sm')]: {
          fontSize: '16px',
          lineHeight: '140%',
        },
      },
    },
  },
}));
